function addCss(fileName) {
  const link = document.createElement('link');

  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = fileName;

  document.head.appendChild(link);
}

addCss('fonts/fonts.css');
